import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowSplitUp"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V4.5H5.56066L12 10.9393L18.4393 4.5H14V3H21V10H19.5V5.56066L12.75 12.3107V21H11.25V12.3107L4.5 5.56066V10H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitUp;
